import React, { useState, ReactElement } from 'react';

interface ExampleExpanderProps {
  children: [ReactElement, ReactElement];
}

const ExampleExpander: React.FC<ExampleExpanderProps> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Destructure children into header and content
  const [headerContent, expandableContent] = React.Children.toArray(
    children,
  ) as [ReactElement, ReactElement];

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const styles = {
    expander: {
      width: '100%',
      border: '1px solid #e0e0e0',
      borderRadius: '4px',
      margin: '0px 0',
      overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    header: {
      padding: '12px 16px',
      backgroundColor: '#f9fafb',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 'bold' as const,
      userSelect: 'none' as const,
      transition: 'background-color 0.2s ease',
    },
    icon: {
      marginLeft: '8px',
      fontSize: '12px',
    },
    content: {
      padding: '16px',
      backgroundColor: '#ffffff',
    },
  };

  return (
    <div style={styles.expander}>
      <div
        style={styles.header}
        onClick={toggleExpand}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = '#eeeeee';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = '#f5f5f5';
        }}
      >
        {headerContent}
        <span style={styles.icon}>{isExpanded ? '▼' : '►'}</span>
      </div>
      {isExpanded && <div style={styles.content}>{expandableContent}</div>}
    </div>
  );
};

export default ExampleExpander;
